import { render, staticRenderFns } from "./notificationSnoozeMenu.vue?vue&type=template&id=309bfdac&scoped=true"
import script from "./notificationSnoozeMenu.vue?vue&type=script&lang=ts"
export * from "./notificationSnoozeMenu.vue?vue&type=script&lang=ts"
import style0 from "./notificationSnoozeMenu.vue?vue&type=style&index=0&id=309bfdac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309bfdac",
  null
  
)

export default component.exports